import { Input, MP3, WAVE, Output, BufferTarget, Conversion, BlobSource, Mp3OutputFormat } from 'mediabunny';

import { ALLOWED_AUDIO_MIME_TYPE } from 'js/config/config';

export type AudioConversionResult = {
  audioBlob: Blob;
  durationSeconds: number;
  audioFile: File;
};

export async function convertAudioToMp3(file: Blob): Promise<AudioConversionResult> {
  const input = new Input({
    formats: [MP3, WAVE],
    source: new BlobSource(file)
  });
  const output = new Output({
    format: new Mp3OutputFormat(),
    target: new BufferTarget()
  });
  const durationSeconds = await input.computeDuration();

  const conversion = await Conversion.init({ input, output });
  if (!conversion.isValid) {
    throw new Error('Audio conversion failed');
  }

  await conversion.execute();

  if (!output.target.buffer) {
    throw new Error('Audio conversion failed: no output buffer');
  }

  const audioBlob = new Blob([output.target.buffer], { type: ALLOWED_AUDIO_MIME_TYPE });
  const audioFile = new File([audioBlob], 'converted.mp3', { type: ALLOWED_AUDIO_MIME_TYPE });

  return { audioBlob, durationSeconds, audioFile };
}
